import React from "react";
import Icon from "../components/Icon";
import QuoteForm from "../components/QuoteForm";
import { contact, certifications, founders, agent } from "../data/siteData";
import "../styles/RequestQuote.css";

export default function RequestQuote() {
  return (
    <div className="tp-quote-page">
      <section className="tp-section tp-quote-page__section">
        <div className="tp-container tp-quote-page__grid">
          <div className="tp-quote-page__intro">
            <span className="tp-eyebrow">Get in Touch</span>
            <h1 className="tp-section-heading">Let's Build Something Together</h1>
            <p>
              Whether you're looking to place a bulk order, request custom colours, or start a
              long-term supply partnership — we'd be glad to hear from you.
            </p>

            <div className="tp-quote-page__detail">
              <Icon name="pin" size={18} />
              <div>
                <span>Location</span>
                <p>{contact.location}</p>
              </div>
            </div>

            <div className="tp-quote-page__detail">
              <Icon name="mail" size={18} />
              <div>
                <span>Email</span>
                <a href={`mailto:${contact.email}`}>{contact.email}</a>
              </div>
            </div>

            <div className="tp-quote-page__detail">
              <Icon name="phone" size={18} />
              <div>
                <span>Call the Founders</span>
                {founders.map((f) => (
                  <p key={f.id}>
                    {f.name} — {f.phone}
                  </p>
                ))}
              </div>
            </div>

            <div className="tp-quote-page__detail">
              <Icon name="globe" size={18} />
              <div>
                <span>{agent.heading}</span>
                <p>{agent.name}</p>
                <p>{agent.altName}</p>
                <p>{agent.phones.join(" · ")}</p>
              </div>
            </div>

            <div className="tp-quote-page__detail">
              <Icon name="checkCircle" size={18} />
              <div>
                <span>Our Commitments</span>
                <p>{certifications.join(" · ")}</p>
              </div>
            </div>
          </div>

          <QuoteForm />
        </div>
      </section>
    </div>
  );
}
